import styled, { css } from 'styled-components';

import { colors } from 'global/colors';
import { Images } from 'util/images';

export const InfoAndScoreContainer = styled.div`
  padding: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;

  @media (max-width: 736px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media print {
    min-height: 450px;
    padding-bottom: 0px;
  }
`;

export const InfoAndScoreBox = styled.div`
  position: relative;
  display: block;
  margin-bottom: 1rem;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  box-shadow: 0 5px 15px rgb(0 0 0 / 30%);
  padding: 20px;
`;

export const Heading = styled.h5`
  color: ${colors.darkBlue};
  font-weight: 700;
  width: 100%;
`;

export const HeadingUnderLine = styled.hr`
  border: 1px solid ${colors.lightGray2};
  border-radius: 2px;
  margin-top: 0px;
  margin-bottom: 5px;
`;

export const InfoLabelsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 100%;
  padding: 10px;
  @media (max-width: 360px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const LabelsContainer = styled.div`
  display: grid;
  ${(props) =>
    props.anonymiseReport &&
    css`
      @media print {
        display: none;
      }
    `}
`;

export const LabelHeading = styled.label`
  color: ${colors.darkGray};
  font-weight: 600;
  margin-bottom: 0px;
  font-size: 15px;
`;

export const LabelValue = styled.label`
  color: ${colors.lightGray2};
  margin-bottom: 0px;
  font-size: 14px;
`;

export const SmallLabelValue = styled.label`
  color: ${colors.lightGray2};
  margin-bottom: 0px;
  font-size: 12px;
`;

export const GaugeImage = styled.img`
  height: 140px;
  width: 280px;
  margin: 30px auto;
  display: block;
`;

export const PointerImage = styled.div`
  transform: rotate(${(props) => props.angle}deg);
  transform-origin: 87% 50%;
  background: url(${Images.gaugePointer});
  background-size: 100% 100%;
  height: 24px;
  width: 80px;
  position: absolute;
  left: calc(50% - 69px);
  top: 90%;
  animation: rotate-gauge-pointer 2s ease;
`;

export const ScoreDescriptionContainer = styled.div`
  text-align: center;
  line-height: 25px;
  margin-top: 25px;
`;

export const PercentageText = styled.h4`
  color: ${colors.darkGray};
  font-weight: 600;
`;

export const InfoIconContainer = styled.div`
  text-align: center;
  margin-top: 10px;

  @media print {
    display: none;
  }
`;

export const InfoIcon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  font-size: 20px;
  color: ${colors.darkGray};
  cursor: pointer;
  ${(props) =>
    props.marginLeft &&
    css`
      margin-left: ${props.marginLeft}px;
    `}
`;

export const ScoreBoxContainer = styled.div`
  margin: 0;
  position: inherit;
  top: 40%;
  transform: translateY(-50%);
  width: 100%;
`;

export const GaugeAndPointerContainer = styled.div`
  position: relative;
`;

export const ActiveTabBox = styled.div`
  padding: 20px;
  max-width: 850px;
  margin: auto;
  ${(props) =>
    props.forPrint &&
    css`
      @media print {
        padding-top: 20px;
        padding-bottom: 10px;
        max-width: initial;
        margin: 0;
        page-break-before: always;
      }
    `}
  ${(props) =>
    props.forCode &&
    css`
      @media print {
        page-break-inside: auto;
      }
    `}

  ${(props) =>
    props.noTopPadding &&
    css`
      @media print {
        padding-top: 0px;
      }
    `}

    ${(props) =>
    props.maxHeightForPrint &&
    css`
      @media print {
        max-height: ${props.maxHeightForPrint};
      }
    `}
`;

export const InnerBorderPrintContainer = styled.div`
  @media print {
    padding: 20px;
    max-width: 850px;
    margin: auto;
  }
`;

export const BorderPrintContainer = styled.div`
  @media print {
    border: 1px solid #dee2e6;
  }
`;

export const DescriptionHeading = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 10px;
  color: ${colors.darkGray};
`;

export const Description = styled.div`
  font-size: 14px;
  h4 {
    font-size: 18px;
  }
  h3 {
    font-size: 20px;
    color: ${colors.darkBlue};
  }
  h2 {
    font-size: 22px;
    color: ${colors.darkBlue};
  }
  img {
    max-width: 80% !important;
    height: auto !important;
    width: auto !important;
  }
`;

export const FreecodeScoreContainer = styled.div`
  text-align: center;
  padding: 20px;
`;

export const FreecodeScore = styled.h1`
  font-weight: 700;
  color: ${colors.darkGray};
`;

export const SeparateContainer = styled.div`
  width: 100%;
  ${(props) =>
    props.extraBoxWithShadow &&
    css`
      padding: 20px;
      @media print {
        padding-top: 0px;
        padding-bottom: 0px;
      }
    `}

  ${(props) =>
    props.maxHeightForPrint &&
    css`
      @media print {
        max-height: ${props.maxHeightForPrint};
      }
    `}
`;

export const SeparateInnerContainer = styled.div`
  ${(props) =>
    props.extraBoxWithShadow &&
    css`
      box-shadow: 0 5px 15px rgb(0 0 0 / 30%);
      padding: 20px;

      @media print {
        border: 1px solid #dee2e6;
      }
    `}

  ${(props) =>
    props.maxHeightForPrint &&
    css`
      @media print {
        max-height: ${props.maxHeightForPrint};
      }
    `}
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  ${(props) =>
    props.alignItemsCenter &&
    css`
      align-items: center;
    `}

  ${(props) =>
    props.marginTop &&
    css`
      margin-top: ${props.marginTop};
    `}

    ${(props) =>
    props.handleSmallDevice &&
    css`
      @media (max-width: 736px) {
        display: block;
      }
    `}
`;

export const CapsuledTab = styled.ul`
  display: flex;
  justify-content: flex-end;
  list-style: none;
  height: 32px;
  margin-bottom: 7px;
  font-size: 12px;
  cursor: pointer;
  z-index: 1;
  width: 100%;

  @media (max-width: 736px) {
    justify-content: flex-start;
    padding-left: 0;
  }

  @media print {
    display: none;
  }
`;

export const LeftCapsuledTab = styled.li`
  border-radius: 75px 0 0 75px;
  border: 2px solid ${colors.gray2};
  padding: 5px 20px 5px 20px;
  border-right-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.active &&
    css`
      border-right-style: solid;
      background-color: ${colors.green};
      color: #fff;
      font-weight: 600;
      border: 2px solid ${colors.green};
    `}
`;

export const RightCapsuledTab = styled.li`
  border-radius: 0 75px 75px 0;
  border: 2px solid #999999;
  padding: 5px 20px 5px 20px;
  border-left-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.active &&
    css`
      border-left-style: solid;
      background-color: ${colors.green};
      color: #fff;
      font-weight: 600;
      border: 2px solid ${colors.green};
    `}
`;

export const QuestionNumberContainer = styled.div`
  display: inline-block;
  border-radius: 2px;
  height: 35px;
  width: 35px;
  line-height: 35px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  margin: 2px;
  transition: all 200ms ease;
  padding: 0 5px;
  vertical-align: top;
  font-weight: bold;
  color: #ffffff;
  opacity: 1;
  background: ${(props) =>
    props.correct === true ? colors.green2 : props.correct === false ? colors.darkRed : '#b6bdbf'};
`;

export const NoQuestionText = styled.p`
  text-align: center;
  font-style: italic;
`;

export const LevelNameText = styled.div`
  font-size: 14px;
`;

export const Scores = styled.p`
  padding: 5px 25px 5px 25px;
  background: green;
  color: white;
  line-height: 30px;
  font-size: 14px;
  font-weight: bold;
  min-width: 115px;
  text-align: center;
  margin-bottom: 0px;

  ${(props) =>
    props.marginRight &&
    css`
      margin-right: ${props.marginRight};
    `}

  ${(props) =>
    props.color === 'bad' &&
    css`
      background: #c65853;
    `}

      ${(props) =>
    props.color === 'poor' &&
    css`
      background: #ff982b;
    `}

    ${(props) =>
    props.color === 'fair' &&
    css`
      background: #ffc500;
    `}

      ${(props) =>
    props.color === 'good' &&
    css`
      background: #7ec666;
    `}

        ${(props) =>
    props.color === 'excellent' &&
    css`
      background: #00a04a;
    `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;

  @media print {
    display: none;
  }
`;

export const FutureSkillLogo = styled.img`
  margin: 0 auto 10px;
  width: 200px;
`;

export const ReportToast = styled.div`
  display: flex;
  align-items: center;
`;

export const ReportTextContainer = styled.div`
  text-align: left;
  display: inline-block;
  margin-left: 10px;
  line-height: 16px;
`;

export const ReportTitle = styled.span`
  font-weight: bold;
  display: block;
`;

export const ReportInfo = styled.span`
  font-size: 10px;
`;
